<editor class="orms-editor" [ngModel]="scopeData.scope" [disabled]="(isEditable$ | async) === false" [init]="init">
</editor>
<app-spinner *ngIf="loading$ | async" [absoluteOverlay]="true"></app-spinner>
